type GleamSparkProps = {
  className?: string;
};

/**
 * Small 4-point sparkle — the one warm `--color-gleam` note, reserved for
 * primary eyebrows (see docs/redesign/reference-identity-study.html's
 * `.spark`/`gleamSpark()`). Purely decorative; size via `className`.
 */
export const GleamSpark = ({ className }: GleamSparkProps) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
    <path
      className="fill-gleam"
      d="M12 2 Q13.4 9 15 10.6 Q22 12 15 13.4 Q13.4 15 12 22 Q10.6 15 9 13.4 Q2 12 9 10.6 Q10.6 9 12 2 Z"
    />
  </svg>
);
